import { IChangeType } from 'src/generated-types/project-version-changes'

export const CHANGE_LABEL_KEY: Record<IChangeType, string> = {
  [IChangeType.Added]: 'changes-added',
  [IChangeType.Modified]: 'changes-modified',
  [IChangeType.Moved]: 'changes-moved',
  [IChangeType.Removed]: 'changes-removed',
}

// Mark shown before a change description and inside the filter chips.
export const CHANGE_GLYPH: Record<IChangeType, string> = {
  [IChangeType.Added]: '+',
  [IChangeType.Modified]: '\u21C4',
  [IChangeType.Moved]: '\u2197',
  [IChangeType.Removed]: '\u2212',
}
